import React from 'react';
import HomePage from './pages/HomePage';
import './styles/global.css';
import FloatingButtons from './components/FloatingButtons';

function App() {
  return (
    <div className="App">
      <HomePage />
      <FloatingButtons/>
    </div>
  );
}

export default App;